/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const BranchInfoPopupContent = styled.div({
  display: 'flex',
  flexDirection: 'column',
  padding: `${token('space.200')} ${token('space.300')}`,
});

export const PopupChildrenWrapper = styled.div({
  cursor: 'pointer',
  display: 'flex',
});
